document.addEventListener("DOMContentLoaded", function () {
  // Select the parent element that exists when the page loads
  // The OG Sub Man content takes a bit longer to load and may not be visible in the DOM initially
  const parentElement = document.body;
  const urlParams = new URLSearchParams(window.location?.search);
  const customerId = urlParams.get("customer");
  const utmSource = urlParams.get("utm_source");
  const utmMedium = urlParams.get("utm_medium");
  const utmCampaign = urlParams.get("utm_campaign");
  const utmContent = urlParams.get("utm_content");

  parentElement.addEventListener("click", function (event) {
    if (
      event.target.matches(
        ".og-change-shipment-date-button button, " +
          ".og-send-shipment-now-button button, " +
          ".og-skip-shipment-button button"
      )
    ) {
      // Get the ancestor og-shipment-header element
      let shipmentHeader = event.target?.closest(".og-shipment-header");

      // Get the data-shipment-id attribute value from the ancestor element
      var orderID = event.target.closest(".og-shipment-header")?.dataset
        ?.shipmentId;
      var buttonText = event.target?.textContent?.trim();
      let shipmentBody = shipmentHeader?.nextElementSibling;

      if (
        shipmentBody &&
        shipmentBody.classList?.contains("og-shipment-body")
      ) {
        // Find all og-product divs inside og-shipment-body
        let products = shipmentBody.querySelectorAll(".og-product");
        let itemIds = [];
        products.forEach(function (product) {
          let itemId = product.getAttribute("og-item-id");
          if (itemId) {
            itemIds.push(itemId);
          }
        });

        Shopify.analytics.publish("rudderstack_track", {
          eventName: `${buttonText} Button Clicked`,
          eventData: {
            "Customer ID": customerId,
            "OG Order ID": orderID,
            "OG External Product ID": itemIds,
          }
        });
      }
    }
  });

  parentElement.addEventListener("click", function (event) {
    if (
      event.target.matches(
        ".og-pause-subscription-button a, " +
          ".og-delete-item-control a, " +
          ".og-change-product-control a, " +
          ".og-cancel-subscription-button a"
      )
    ) {
      // Get the data-shipment-id attribute value from the ancestor element
      let shipmentBody = event.target.closest(".og-shipment-body");
      let shipmentHeader = shipmentBody?.previousElementSibling;
      var orderID = shipmentHeader?.dataset?.shipmentId;
      var linkText = event.target?.textContent?.trim();
      let product = event.target.closest(".og-product");

      if (product) {
        // Find all og-product divs inside og-shipment-body
        let productName =
          product.querySelector(".og-product-name a")?.textContent;
        let productId = product.getAttribute("og-item-id");
        let subscriptionId = product.getAttribute("og-subscription-id");
        let isSubscriptionItem =
          subscriptionId !== undefined && subscriptionId !== "null"
            ? true
            : false;

        Shopify.analytics.publish("rudderstack_track", {
          eventName: `${linkText} Link Clicked`,
          eventData: {
            "Customer ID": customerId,
            "Product Name": productName,
            "OG External Product ID": productId,
            "Subscription Item": isSubscriptionItem,
            "OG Subscription ID": subscriptionId,
            "OG Order ID": orderID,
          }
        });
      }
    }
  });

  parentElement.addEventListener("click", function (event) {
    if (
      event.target.matches(".og-change-billing-button a") ||
      event.target.matches(".og-dialog-footer button")
    ) {
      let shipmentFooter = event.target?.closest(".og-shipment-footer");
      let shipmentBody = shipmentFooter?.previousElementSibling;
      let shipmentHeader = shipmentBody?.previousElementSibling;
      let orderID = shipmentHeader?.dataset?.shipmentId;
      const subscriberType = window.subscriberType;

      if (
        shipmentBody &&
        shipmentBody.classList?.contains("og-shipment-body")
      ) {
        // Find all og-product divs inside og-shipment-body
        let products = shipmentBody.querySelectorAll(".og-product");
        let productIds = [];
        let productNames = [];
        let paymentErrorMsg = "";
        let currentPaymentMethod = "";
        let expDate = "";
        let eventName = "";

        if (event.target.matches(".og-change-billing-button a")) {
          eventName = "Edit Payment";
        } else {
          eventName = "Edit Payment Send Email";
        }

        products.forEach(function (product) {
          let productId = product.getAttribute("og-item-id");
          let productName =
            product.querySelector(".og-product-name a")?.textContent;
          if (productId) {
            productIds.push(productId);
          }

          if (productName) {
            productNames.push(productName);
          }
        });

        if (
          shipmentFooter &&
          shipmentFooter.classList?.contains("og-shipment-footer")
        ) {
          paymentErrorMsg =
            shipmentFooter
              .querySelector(".og-payment-is-expiring")
              ?.textContent?.trim() || "";
          currentPaymentMethod =
            shipmentFooter.querySelector(".og-payment-type")?.textContent || "";
          expDate =
            shipmentFooter
              .querySelector(".og-exp-date")
              ?.textContent?.split(" ")?.[2] || "";
        }

        Shopify.analytics.publish("rudderstack_track", {
          eventName: eventName,
          eventData: {
            productId: productIds,
            productName: productNames,
            "OG Order ID": orderID,
            paymentErrorMethod: paymentErrorMsg,
            currentPaymentMethod: currentPaymentMethod,
            expDate: expDate,
            "Customer ID": customerId,
            utm_source: utmSource,
            utm_medium: utmMedium,
            utm_campaign: utmCampaign,
            utm_content: utmContent,
            subscriberType: subscriberType,
          }
        });
      }
    }
  });

  parentElement.addEventListener("change", function (event) {
    if (event.target.matches('select[name="quantity"], .quantity-select')) {
      const quantity = event.target.value;
      const product = event.target.closest(".og-product");

      if (!product) {
        return;
      }

      const productName =
        product.querySelector(".og-product-name a")?.textContent;
      const productId = product.getAttribute("og-item-id");
      const subscriptionId = product.getAttribute("og-subscription-id");
      const isSubscriptionItem =
        subscriptionId !== undefined && subscriptionId !== "null";
      const shipmentHeader =
        product.closest(".og-shipment-body")?.previousElementSibling;
      const orderID = shipmentHeader?.dataset?.shipmentId;

      Shopify.analytics.publish("rudderstack_track", {
        eventName: "Add To Order Product Quantity Changed",
        eventData: {
          "Customer ID": customerId,
          "New Quantity": quantity,
          "Product Name": productName,
          "OG External Product ID": productId,
          "Subscription Item": isSubscriptionItem,
          "OG Subscription ID": subscriptionId,
          "OG Order ID": orderID,
        }
      });
    }
  });
});
